/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

/**
 * Internal dependencies
 */
import BaseTopbar from 'layout/topbar';
import Items from 'layout/topbar/items';
import Item from 'layout/topbar/item';
import Section from 'layout/topbar/section';
import { Heading, Box } from '@towersystems/towersystems-design-system';
import { getCurrentSupport } from 'state/current-support/selectors';
import { getCurrentWeb } from 'state/current-web/selectors';


/**
 * Style dependencies
 */
import './styles.scss';

const Topbar = (props) => {
    const [isStuck, setIsStuck] = useState(false);

    useEffect(() => {
        const header = document.getElementById('sticky-topbar');
        const sticky = header.offsetTop + 50; // + the height of topbar

        const scrollCallBack = window.addEventListener('scroll', () => {
            if (window.pageYOffset > sticky) {
                setIsStuck(true);
            } else {
                setIsStuck(false);
            }
        });
        return () => {
            window.removeEventListener('scroll', scrollCallBack);
        };
    }, []);

    const classes = classnames('me-topbar');
    const navbarClasses = classnames('me-topbar__nav', 'space-between', { 'is-stuck': isStuck });

    /*{props.hasCurrentSupport && (
                            <Item label='Dashboard' path='/' selected={props.selected == 'dashboard'} />
                        )}
                        <Item label='Support Plan' path='/dashboard/support' selected={props.selected == 'support'} />
                        {(props.hasCurrentRental.length>0) && (
                        <Item label='Rental Plan' path='/dashboard/rental' selected={props.selected == 'rental'} />
                        )}
                        {(props.hasCurrentCloudHosting>0) && (
                        <Item label='Cloud Hosting Plan' path='/dashboard/cloud-hosting' selected={props.selected == 'cloud-hosting'} />
                        )}*/

    return (
        <Box id='sticky-topbar' className={classes}>
            <BaseTopbar className={navbarClasses}>
                <Section>
                    <Items>
                        <Item label='Dashboard' path='/' selected={props.selected == 'dashboard'} />

                        {/* {!props.hasCurrentWeb && (
                            <Item label='Shopify Development Plan' path='/dashboard/shopify-development/new' selected={props.selected == 'shopify'} />
                        )} */}
                        <Item label='Plans' path='/dashboard/plans' selected={props.selected == 'plans'} />
                    </Items>
                </Section>
                <Section>
                    <Items>
                        <Item label='Help' path='//www.towersystems.com.au/help.html' icon={{ name: 'FiHelpCircle' }} />
                        <Item className='me-topbar__logout' label='Logout' path='/logout' icon={{ name: 'FiUser' }} />
                    </Items>
                </Section>
            </BaseTopbar>
            <Box
                padding='xxlarge'
                className='me-topbar__header'
                display='flex'
                justifyContent='spaceBetween'
                alignItems='center'
            >
                <Box paddingTop='xxlarge' paddingBottom='xlarge'>
                    <Heading className='page-title' level={2}>
                        {props.title}
                    </Heading>
                    {props.subTitle && (
                        <Heading className='page-sub-title' level={3}>
                            {props.subTitle}
                        </Heading>
                    )}
                </Box>
                <Box>{props.children}</Box>
            </Box>
        </Box>
    );
};

export default connect((state) => ({
    hasCurrentSupport: !!getCurrentSupport(state),
    hasCurrentWeb: !!getCurrentWeb(state),
}))(Topbar);
